import React, { type JSX, type PropsWithChildren, useState } from "react";

import { SupAccordion, SupAccordionSummary, SupAccordionDetails, SupBadge, SupText } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";

export interface FormGroupGroup extends PropsWithChildren {
  className?: string;
  title?: string;
  description?: string | JSX.Element;
  count?: number;
  collapsible?: boolean;
  defaultExpanded?: boolean;
  invalid?: boolean;
}

export function SupFormGroup({ className, title, description, count = 0, collapsible = false, invalid = false, defaultExpanded, children }: FormGroupGroup) {
  const [expanded, setExpanded] = useState(defaultExpanded);


  const descriptionEl = description ? (<SupText variant="caption" className={twMerge(invalid ? "text-error-700" : "text-neutral-900")}>
      {description}
    </SupText>) : null;

  const titleEl = title ? (
    <div className={twMerge("inline-flex flex-col items-start space-y-2 justify-center", !description && "mb-6" )}>
      <SupText
        as="h3"
        weight="bold"
        variant="subtitle1"
        className={twMerge(
          "flex items-center",
          invalid ? "text-error-700" : "text-neutral-900",
        )}
      >
        {title}
        {count > 0 ? <SupBadge className="ml-2" variant="count" color={invalid ? "error" : "primary"} count={count} /> : null}
      </SupText>
      {descriptionEl}
    </div>
  ) : null;


  return (
    <SupAccordion className={twMerge("sup-form-group", className)} expanded={expanded} collapsible={collapsible} onChange={setExpanded}>
      {titleEl && <SupAccordionSummary
        className={collapsible ? "border-[.5px] border-neutral-300 px-4 py-6" : undefined}
        iconClassName={collapsible ? "right-4" : undefined}
        expandIcon={!collapsible ? null : undefined}
      >{titleEl}</SupAccordionSummary>}

      <SupAccordionDetails className="flex-col">
        {children}
      </SupAccordionDetails>
    </SupAccordion>
  );
}
